module.exports = __webpack_public_path__ + "static/img/1111.f2eaf16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1111.png
// module id = fjbK
// module chunks = 1